(function () {
  'use strict';

  var notifyEl = null;
  var notifyTimer = null;
  var NOTIFY_AUTODISMISS_MS = 8000;

  function init() {
    notifyEl = document.querySelector('[data-pp-cart-notify]');
    if (notifyEl) {
      var closers = notifyEl.querySelectorAll('[data-pp-cart-close]');
      for (var c = 0; c < closers.length; c++) {
        closers[c].addEventListener('click', hideNotify);
      }
    }

    initViewToggle();
    initFiltersAutoSubmit();
    initSort();
    initInCollectionSearch();

    initExistingCards();
    initObserver();
    initImageSkeletons();

    syncCartIndicators();
    document.addEventListener('pp:cart-updated', function (e) {
      if (e && e.detail) {
        applyCartIndicators(e.detail);
      } else {
        syncCartIndicators();
      }
    });
    // 5-oct-2026: el carrito también cambia desde Paco y «Te Toca», que
    // avisan con `pp:cart:updated` (sin el carrito). El «− N +» de celular
    // de las tarjetas los sigue igual.
    document.addEventListener('pp:cart:updated', function (e) {
      if (e && e.detail && e.detail.items) {
        applyCartIndicators(e.detail);
      } else {
        syncCartIndicators();
      }
    });
  }

  function initExistingCards() {
    var cards = document.querySelectorAll('[data-pp-card]');
    for (var i = 0; i < cards.length; i++) {
      initCardOnce(cards[i]);
    }
  }

  function initCardOnce(card) {
    if (!card || card.dataset.ppCardInit === 'true') return;
    card.dataset.ppCardInit = 'true';
    revealLoadedImages(card);
    initCard(card);
  }

  // ── Shimmer de imagen ────────────────────────────────────────────────
  // Shopify `image_tag` NO renderiza onload/onerror (los sanitiza), así que
  // ocultamos el skeleton desde JS: marcamos el frame .pp-prod-card__media
  // como --loaded cuando su <img> primaria termina de cargar (load o error).
  function markMediaLoaded(img) {
    if (!img || !img.classList || !img.classList.contains('pp-prod-card__img--primary')) return;
    var media = img.closest('.pp-prod-card__media');
    if (media) media.classList.add('pp-prod-card__media--loaded');
  }

  function revealLoadedImages(root) {
    var imgs = (root || document).querySelectorAll('.pp-prod-card__img--primary');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].complete && imgs[i].naturalWidth > 0) markMediaLoaded(imgs[i]);
    }
  }

  function initImageSkeletons() {
    // 'load'/'error' no burbujean → capture:true para agarrarlos a nivel
    // document, incluidas las imgs de cards inyectadas por fetch.
    document.addEventListener('load', function (e) { markMediaLoaded(e.target); }, true);
    document.addEventListener('error', function (e) { markMediaLoaded(e.target); }, true);
    revealLoadedImages(document); // imgs ya cargadas antes de este script
  }

  // <product-recommendations> (sección Productos Relacionados) inyecta
  // las cards via fetch ASYNC despues del DOMContentLoaded. Sin observer,
  // esas cards quedan sin qty stepper handlers ni submit handlers (qty
  // no cambia, AGREGAR no funciona). Mutation observer detecta cards
  // dynamically inserted y las inicializa una sola vez.
  // Debounced cart re-sync para evitar storms si llegan muchas cards
  // en pocos ms (e.g., paginación de Productos Relacionados via fetch).
  var _syncCartTimer = null;
  function scheduleSyncCart() {
    if (_syncCartTimer) return;
    _syncCartTimer = setTimeout(function () {
      _syncCartTimer = null;
      syncCartIndicators();
    }, 250);
  }

  function initObserver() {
    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function (mutations) {
      // BUG fix: el observer observa todo el body, así que mutaciones de
      // Shopify Analytics, Loox, web pixels, etc. lo disparaban en cada
      // tick. El sync de cart NO debe correr salvo que efectivamente se
      // hayan agregado cards nuevas — el cart no cambia porque Loox
      // pinte estrellas. Antes esto era loop infinito de /cart.js con
      // carts grandes (390 items → applyCartIndicators dispara 390 input
      // events → posibles mutaciones cascade → más fetches).
      var foundNewCards = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-pp-card]')) {
            initCardOnce(node);
            foundNewCards = true;
          }
          if (node.querySelectorAll) {
            var inner = node.querySelectorAll('[data-pp-card]');
            for (var i = 0; i < inner.length; i++) {
              initCardOnce(inner[i]);
              foundNewCards = true;
            }
          }
        });
      });
      if (foundNewCards) {
        scheduleSyncCart();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function syncCartIndicators() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(applyCartIndicators)
      .catch(function () { /* silent */ });
  }

  // La burbuja del carrito del encabezado (sections/header.liquid) sale del
  // Liquid y nadie la movía al agregar desde una tarjeta: decía 0 (o el
  // número viejo) hasta recargar (medido 5-oct-2026, celular y escritorio).
  // Cada cambio de carrito que pasa por aquí la pone al día, con el MISMO
  // marcado que pinta el Liquid.
  function pintarBurbujaCarrito(cuantos) {
    if (typeof cuantos !== 'number' || !isFinite(cuantos)) return;
    var icono = document.querySelector('#cart-icon-bubble .svg-wrapper');
    if (!icono) return;
    var burbuja = icono.querySelector('.cart-count-bubble');
    if (cuantos <= 0) {
      if (burbuja) burbuja.parentNode.removeChild(burbuja);
      return;
    }
    if (!burbuja) {
      burbuja = document.createElement('div');
      burbuja.className = 'cart-count-bubble';
      var visible = document.createElement('span');
      visible.setAttribute('aria-hidden', 'true');
      var lector = document.createElement('span');
      lector.className = 'visually-hidden';
      burbuja.appendChild(visible);
      burbuja.appendChild(lector);
      icono.appendChild(burbuja);
    }
    var spans = burbuja.querySelectorAll('span');
    if (spans[0]) spans[0].textContent = cuantos < 100 ? String(cuantos) : '99+';
    if (spans[1]) spans[1].textContent = cuantos + (cuantos === 1 ? ' artículo' : ' artículos');
  }

  function applyCartIndicators(cart) {
    if (!cart || !cart.items) return;
    pintarBurbujaCarrito(cart.item_count);
    // La tarjeta cuenta y cambia SÓLO las líneas sin propiedades de su
    // variante (22-oct-2026). Antes «N EN TU CARRITO» sumaba también la
    // personalizada: con sólo ésa la tarjeta decía «1 EN TU CARRITO», el
    // «− N +» no salía (no hay línea lisa que cambiar) y el botón mandaba a
    // /cart — no había cómo sumar desde ahí (C-2662, medido en vivo). Ahora
    // esa tarjeta dice AGREGAR y agrega una línea lisa nueva; la
    // personalizada se queda intacta (se cambia en /cart con su cobro).
    var planas = lineasPlanas(cart);
    var cards = document.querySelectorAll('[data-pp-card]');
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      var form = card.querySelector('[data-pp-form]');
      if (!form) continue;
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) continue;
      var vid = parseInt(idInput.value, 10);
      var lisa = planas[vid] || null;
      var qty = lisa ? lisa.total : 0;
      // Lo que el cliente ya picó en el «− N +» y aún no confirma el carrito.
      var pendiente = form.__ppStepper ? form.__ppStepper.pendiente() : null;
      if (pendiente !== null) qty = pendiente;
      var antes = parseInt(form.getAttribute('data-pp-cart-qty'), 10) || 0;
      form.setAttribute('data-pp-cart-qty', String(qty));
      if (lisa) form.setAttribute('data-pp-cart-key', lisa.key + '|' + lisa.cantidadLinea + '|' + lisa.total);
      else form.removeAttribute('data-pp-cart-key');

      var qtyInput = form.querySelector('[data-pp-qty]');
      if (qtyInput) {
        if (qty > 0) {
          qtyInput.value = String(qty);
        } else if (antes > 0 && form.__ppStepper && esCelular()) {
          // Celular: la línea «25 cajas · $299» regresa a 1 paquete al
          // quitarla (el selector no se ve; no puede quedarse en 3).
          qtyInput.value = '1';
        }
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      if (form.__ppStepper) form.__ppStepper.pintar(lisa);
    }
  }

  // ── Celular (<750px): AGREGAR se vuelve «− N +» (5-oct-2026) ──────────
  // Como la barra de la ficha de Paco (#973): en celular el selector de
  // cantidad no se ve, AGREGAR va a todo el ancho y, con la variante en el
  // carrito, en su MISMO lugar sale el «− N +» del carrito (N = paquetes de
  // esa variante; con 1 el «−» es la basura y al quitarla regresa
  // AGREGAR). El «+»/«−» cambian ESA línea con /cart/change.js por su key:
  // sin cajón ni aviso en cada toque. Cada toque se pinta AL INSTANTE (el
  // número y la línea «175 cajas · $…») y nunca bloquea; el carrito se pone
  // al día UNA vez, con la cantidad final, STEPPER_ESPERA_MS después del
  // último toque (22-oct-2026). Si falla regresa a lo que tiene el carrito
  // y avisa. Escritorio no cambia: el
  // stepper nace `hidden` y pp-product-card.css sólo lo enseña <750px.
  //
  // N cuenta las líneas SIN propiedades: una personalizada (con su arte y
  // su cobro) se quita en /cart por su camino (pp-quitar-con-su-cobro.js),
  // nunca bajándola a 0 desde una tarjeta.
  var BASURA_D = 'M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6'; // la de Paco

  function esCelular() {
    try { return window.matchMedia('(max-width: 749px)').matches; } catch (e) { return false; }
  }

  function sinPropiedades(item) {
    var p = item && item.properties;
    if (!p) return true;
    for (var k in p) {
      if (Object.prototype.hasOwnProperty.call(p, k) && p[k] !== null && p[k] !== '') return false;
    }
    return true;
  }

  /** { variant_id: { key, cantidadLinea, total } } con las líneas sin
   * propiedades: la key y la cantidad de la PRIMERA (la que cambia el
   * stepper) y el total de esa variante en líneas planas (lo que dice N). */
  function lineasPlanas(cart) {
    var out = {};
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!sinPropiedades(it)) continue;
      var v = it.variant_id;
      if (!out[v]) out[v] = { key: it.key, cantidadLinea: it.quantity, total: 0 };
      out[v].total += it.quantity;
    }
    return out;
  }

  function avisarCarrito(cart) {
    // Las dos familias de oyentes del tema: la tienda (pp:cart-updated,
    // contador, cajón si ya está abierto, crédito) y Paco / Te Toca
    // (pp:cart:updated). Ninguna de las dos ABRE el cajón.
    document.dispatchEvent(new CustomEvent('pp:cart-updated', { detail: cart }));
    document.dispatchEvent(new CustomEvent('pp:cart:updated', { detail: cart }));
  }

  // Cuánto espera el «− N +» después del ÚLTIMO toque para mandar la
  // cantidad final al carrito (22-oct-2026, el dueño: «quiero picar de 7 a
  // 15 sin esperar»). Antes cada toque era un /cart/change.js de ~3 s y
  // bloqueaba los botones mientras iba.
  var STEPPER_ESPERA_MS = 600;

  function montarStepperMovil(card, form, addBtn) {
    if (!addBtn || form.__ppStepper) return;
    // El «+» redondo de las recomendaciones del cajón es otra pieza.
    if (card.closest && card.closest('.pp-cart-drawer__recs-list')) return;
    var titulo = card.querySelector('.pp-prod-card__title');
    var nombre = titulo ? titulo.textContent.replace(/\s+/g, ' ').trim() : 'este producto';

    var caja = document.createElement('div');
    caja.className = 'pp-prod-card__stepper';
    caja.setAttribute('role', 'group');
    caja.setAttribute('aria-label', 'Cantidad en el carrito');
    caja.hidden = true;
    var menos = document.createElement('button');
    menos.type = 'button';
    menos.className = 'pp-prod-card__stepper-btn pp-prod-card__stepper-menos';
    var n = document.createElement('span');
    n.className = 'pp-prod-card__stepper-n';
    n.setAttribute('aria-live', 'polite');
    var mas = document.createElement('button');
    mas.type = 'button';
    mas.className = 'pp-prod-card__stepper-btn pp-prod-card__stepper-mas';
    mas.textContent = '+';
    mas.setAttribute('aria-label', 'Agregar un paquete de ' + nombre);
    caja.appendChild(menos);
    caja.appendChild(n);
    caja.appendChild(mas);
    addBtn.parentNode.insertBefore(caja, addBtn.nextSibling);
    form.setAttribute('data-pp-stepper-movil', '');

    var linea = null;     // { key, cantidadLinea, total } — lo que dijo el carrito
    var deseado = null;   // lo que el cliente ya picó y aún no confirma el carrito
    var reloj = null;     // la espera tras el último toque
    var enVuelo = false;  // hay un /cart/change.js en camino
    var qtyInput = form.querySelector('[data-pp-qty]');

    function cara(valor) {
      menos.textContent = '';
      if (valor <= 1) {
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor');
        svg.setAttribute('stroke-width', '2');
        svg.setAttribute('stroke-linecap', 'round');
        svg.setAttribute('stroke-linejoin', 'round');
        svg.setAttribute('aria-hidden', 'true');
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', BASURA_D);
        svg.appendChild(path);
        menos.appendChild(svg);
        menos.classList.add('pp-prod-card__stepper-menos--basura');
        menos.setAttribute('aria-label', 'Quitar ' + nombre + ' del carrito');
      } else {
        menos.textContent = '−';
        menos.classList.remove('pp-prod-card__stepper-menos--basura');
        menos.setAttribute('aria-label', 'Quitar un paquete de ' + nombre);
      }
      n.textContent = String(valor);
    }

    /** Pinta la tarjeta en `valor` paquetes AL INSTANTE: el número, el
     * «175 cajas · $1,283 MXN», la píldora activa y, en 0, AGREGAR. */
    function mostrar(valor) {
      if (valor > 0) {
        cara(valor);
        caja.hidden = false;
        form.setAttribute('data-pp-en-carrito', '');
      } else {
        caja.hidden = true;
        form.removeAttribute('data-pp-en-carrito');
      }
      form.setAttribute('data-pp-cart-qty', String(Math.max(0, valor)));
      if (qtyInput) {
        qtyInput.value = String(Math.max(1, valor));
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    function pintar(l) {
      linea = l && l.total > 0 ? l : null;
      // Lo que el cliente ya picó manda sobre lo que trae el carrito: un
      // aviso de otra parte (o la respuesta de un cambio anterior) no le
      // regresa el número bajo el dedo.
      if (deseado !== null) { cara(deseado > 0 ? deseado : 1); return; }
      if (!linea) {
        caja.hidden = true;
        form.removeAttribute('data-pp-en-carrito');
        return;
      }
      cara(linea.total);
      caja.hidden = false;
      form.setAttribute('data-pp-en-carrito', '');
    }

    /** El cliente pidió `nuevo` paquetes: se pinta YA y el carrito se pone
     * al día UNA vez cuando deja de picar (en 0, la basura, de inmediato). */
    function pedir(nuevo) {
      if (!linea && deseado === null) return;
      nuevo = Math.max(0, nuevo);
      deseado = nuevo;
      // El aviso «Agregado al carrito · Cantidad: 1» del primer AGREGAR ya
      // no dice la verdad con el «−»/«+»: se va (el stepper ya enseña N).
      if (notifyEl && !notifyEl.hasAttribute('hidden')) hideNotify();
      mostrar(nuevo);
      clearTimeout(reloj);
      reloj = setTimeout(sincronizar, nuevo === 0 ? 0 : STEPPER_ESPERA_MS);
    }

    /** Manda al carrito la cantidad final pedida (una sola llamada). */
    function sincronizar() {
      reloj = null;
      if (deseado === null) return;
      if (enVuelo) return; // al volver la respuesta se manda lo que falte
      if (!linea) { deseado = null; mostrar(0); return; }
      if (deseado === linea.total) { deseado = null; pintar(linea); return; }
      var objetivo = deseado;
      var cantidadLinea = Math.max(0, linea.cantidadLinea + (objetivo - linea.total));
      enVuelo = true;
      caja.setAttribute('aria-busy', 'true');
      var body = new URLSearchParams();
      body.append('id', linea.key);
      body.append('quantity', String(cantidadLinea));
      fetch('/cart/change.js', {
        method: 'POST',
        body: body,
        headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' }
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; }, function () { throw new Error(''); });
          return r.json();
        })
        .then(function (cart) {
          enVuelo = false;
          caja.removeAttribute('aria-busy');
          // Si el cliente no picó más mientras iba, el carrito ya manda.
          if (deseado === objetivo && !reloj) deseado = null;
          avisarCarrito(cart); // → applyCartIndicators repinta TODAS las tarjetas
          if (deseado !== null && !reloj) sincronizar(); // picó más mientras iba
        })
        .catch(function (err) {
          enVuelo = false;
          caja.removeAttribute('aria-busy');
          clearTimeout(reloj);
          reloj = null;
          deseado = null;
          // Regresa a lo que tiene el carrito y lo relee por si cambió.
          if (linea) mostrar(linea.total); else mostrar(0);
          syncCartIndicators();
          var msg = (err && (err.description || err.message)) || 'No se pudo actualizar el carrito.';
          showNotifyError(msg);
        });
    }

    menos.addEventListener('click', function (e) {
      e.preventDefault();
      var base = deseado !== null ? deseado : (linea ? linea.total : 0);
      if (base > 0) pedir(base - 1);
    });
    mas.addEventListener('click', function (e) {
      e.preventDefault();
      var base = deseado !== null ? deseado : (linea ? linea.total : 0);
      if (base > 0) pedir(base + 1);
    });

    form.__ppStepper = {
      pintar: pintar,
      enCarrito: function () { return deseado !== null ? deseado > 0 : !!linea; },
      // Lo que el cliente picó y el carrito aún no confirma (o null).
      pendiente: function () { return deseado; },
      // La misma cantidad que ya tiene no manda nada al carrito.
      ponerEn: function (cantidad) {
        var actual = deseado !== null ? deseado : (linea ? linea.total : 0);
        if ((linea || deseado !== null) && cantidad !== actual) pedir(cantidad);
      }
    };
  }

  function initSort() {
    var select = document.querySelector('[data-pp-sort]');
    if (!select) return;
    select.addEventListener('change', function () {
      try {
        var url = new URL(window.location.href);
        if (select.value) {
          url.searchParams.set('sort_by', select.value);
        } else {
          url.searchParams.delete('sort_by');
        }
        url.searchParams.delete('page');
        window.location.href = url.toString();
      } catch (e) {
        var form = document.createElement('form');
        form.method = 'get';
        form.action = window.location.pathname;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'sort_by';
        input.value = select.value;
        form.appendChild(input);
        document.body.appendChild(form);
        form.submit();
      }
    });
  }

  // ── In-collection search ─────────────────────────────────────────
  // Filtra TODA la colección (no solo la página visible) por SKU +
  // título + medidas + material. Tokens AND: "10x10 cinta" matchea
  // sólo cards con ambas palabras. Acentos ignorados ("cartón" =
  // "carton").
  //
  // Estrategia: al primer focus, AJAX fetch de las páginas restantes
  // (/collections/<handle>?page=2,3...) para traer los CARDS REALES
  // server-rendered (con tier pills, qty stepper, add-to-cart). Se
  // appendan al grid como hidden y se inicializan vía initCard.
  // Cuando el usuario filtra, todos los cards (locales + extras) se
  // muestran/ocultan según matcheen el query. Cuando limpia, los
  // extras vuelven a estar hidden y solo se ven los locales (page 1).
  function initInCollectionSearch() {
    // LA CAJA DE LA COLECCIÓN (FASE 2, medido 24-oct-2026): el buscador del
    // encabezado también lleva data-pp-search-wrap y data-pp-search-input y
    // va ANTES en el documento, así que `document.querySelector` agarraba ése
    // y el de la colección no filtraba nada (en vivo: escribir «30» dejaba los
    // 24 y nunca traía las otras páginas). Sólo la de la colección trae
    // data-pp-collection-handle.
    var wrap = document.querySelector('[data-pp-search-wrap][data-pp-collection-handle]');
    var input = wrap ? wrap.querySelector('[data-pp-search-input]') : null;
    if (!input) return;

    var grid = document.querySelector('[data-pp-grid]');
    if (!grid) return;
    var localItems = Array.prototype.slice.call(
      grid.querySelectorAll('[data-pp-grid-item]:not([data-pp-extra])')
    );
    if (!localItems.length) return;

    var collectionHandle = wrap ? wrap.getAttribute('data-pp-collection-handle') : null;
    var collectionTotal = wrap ? parseInt(wrap.getAttribute('data-pp-collection-total'), 10) : localItems.length;
    var perPage = wrap ? parseInt(wrap.getAttribute('data-pp-per-page'), 10) : 0;
    if (!perPage || perPage <= 0) perPage = localItems.length || 24;

    var countNumEl = document.querySelector('[data-pp-search-count-num]');
    var emptyEl = document.querySelector('[data-pp-search-empty]');
    var emptyQueryEl = document.querySelector('[data-pp-search-empty-query]');
    var clearBtns = document.querySelectorAll('[data-pp-search-clear]');

    function normalize(str) {
      return (str || '')
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '');
    }

    // allCards array unifies locals + extras for filter logic.
    // Each entry: { element, hay, isLocal }.
    var allCards = [];
    for (var i = 0; i < localItems.length; i++) {
      var searchEl = localItems[i].querySelector('[data-pp-search]');
      allCards.push({
        element: localItems[i],
        hay: searchEl ? normalize(searchEl.getAttribute('data-pp-search')) : '',
        isLocal: true
      });
    }

    // Lazy-fetch additional pages and inject their real cards.
    // Uses Section Rendering API via ?sections=<id> when possible;
    // falls back to full HTML parse if sections endpoint not available.
    var extrasLoaded = false;
    var extrasPromise = null;
    function ensureExtras() {
      if (extrasLoaded) return Promise.resolve();
      if (extrasPromise) return extrasPromise;
      if (!collectionHandle) { extrasLoaded = true; return Promise.resolve(); }

      if (collectionTotal <= perPage) {
        extrasLoaded = true;
        return Promise.resolve();
      }
      var totalPages = Math.ceil(collectionTotal / perPage);
      if (totalPages <= 1) { extrasLoaded = true; return Promise.resolve(); }

      // Preserve any active filter/sort URL params so AJAX'd pages match
      // the same filter state as the rendered page.
      var baseQuery = window.location.search || '';
      // Strip page=N if present so we can override.
      baseQuery = baseQuery.replace(/[?&]page=\d+/g, '');
      if (baseQuery.charAt(0) === '?') baseQuery = '&' + baseQuery.slice(1);

      var promises = [];
      for (var p = 2; p <= totalPages; p++) {
        // FASE 2: una página que «Cargar más» ya trajo no se pide otra vez.
        if (grid.querySelector('[data-pp-grid-item][data-pp-pagina="' + p + '"]')) continue;
        var url = '/collections/' + collectionHandle + '?page=' + p + baseQuery;
        promises.push(
          fetch(url, { headers: { Accept: 'text/html' } })
            .then(function (r) { return r.text(); })
            .then(parsePageAndAppend)
            .catch(function () { /* tolerate one page failing */ })
        );
      }
      extrasPromise = Promise.all(promises).then(function () {
        extrasLoaded = true;
        // Sync cart counts for the freshly added cards.
        if (typeof syncCartIndicators === 'function') syncCartIndicators();
      });
      return extrasPromise;
    }

    function parsePageAndAppend(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newItems = doc.querySelectorAll('[data-pp-grid-item]');
      for (var i = 0; i < newItems.length; i++) {
        var item = newItems[i];
        item.hidden = true;
        item.setAttribute('data-pp-extra', 'true');
        grid.appendChild(item);

        // Initialize the card so qty stepper, tier pills, add-to-cart all work.
        var card = item.querySelector('[data-pp-card]');
        if (card && typeof initCard === 'function') {
          try { initCard(card); } catch (e) { /* ignore */ }
        }

        var sEl = item.querySelector('[data-pp-search]');
        allCards.push({
          element: item,
          hay: sEl ? normalize(sEl.getAttribute('data-pp-search')) : '',
          isLocal: false
        });
      }
    }

    function tokensMatch(hay, tokens) {
      for (var k = 0; k < tokens.length; k++) {
        if (hay.indexOf(tokens[k]) === -1) return false;
      }
      return true;
    }

    function applyFilter() {
      var raw = input.value.trim();
      var hasQuery = raw.length > 0;
      var tokens = hasQuery ? normalize(raw).split(/\s+/).filter(Boolean) : [];

      // Toggle clear button
      for (var c = 0; c < clearBtns.length; c++) {
        if (clearBtns[c].closest('[data-pp-search-wrap]')) {
          clearBtns[c].hidden = !hasQuery;
        }
      }

      // FASE 2: mientras hay búsqueda, las tarjetas especiales no estorban
      // entre los resultados (pp-tarjeta-a-la-medida.css las esconde).
      if (hasQuery) grid.setAttribute('data-pp-buscando', '');
      else grid.removeAttribute('data-pp-buscando');

      if (!hasQuery) {
        // Default state: show locals, hide extras. «Local» lo dice el DOM:
        // «Cargar más» le quita data-pp-extra a una página que ya estaba.
        for (var v = 0; v < allCards.length; v++) {
          allCards[v].element.hidden = allCards[v].element.hasAttribute('data-pp-extra');
        }
        if (countNumEl) countNumEl.textContent = collectionTotal || localItems.length;
        if (emptyEl) emptyEl.hidden = true;
        grid.hidden = false;
        return;
      }

      // Filter mode: hide all, then show matching across both locals + extras.
      var visible = 0;
      for (var j = 0; j < allCards.length; j++) {
        var match = tokensMatch(allCards[j].hay, tokens);
        allCards[j].element.hidden = !match;
        if (match) visible++;
      }

      if (countNumEl) countNumEl.textContent = visible;
      if (emptyEl) {
        if (visible === 0) {
          if (emptyQueryEl) emptyQueryEl.textContent = '«' + raw + '»';
          emptyEl.hidden = false;
          grid.hidden = true;
        } else {
          emptyEl.hidden = true;
          grid.hidden = false;
        }
      }

      // If extras not loaded yet, fetch and re-apply when done so
      // matches from pages 2+ show up.
      if (!extrasLoaded) {
        ensureExtras().then(function () {
          if (input.value.trim() === raw) applyFilter();
        });
      }
    }

    function clear() {
      input.value = '';
      applyFilter();
      input.focus();
    }

    // Pre-warm extras on first focus so by the time user types, cards
    // from pages 2+ are usually already in the DOM.
    var prewarmed = false;
    function preWarm() {
      if (prewarmed) return;
      prewarmed = true;
      ensureExtras();
    }
    input.addEventListener('focus', preWarm);

    // FASE 2: lo que agrega «Cargar más» (assets/pp-coleccion-cargar-mas.js)
    // cuenta como propio de la página; si ya estaba (extra destapado), no se
    // duplica en la lista.
    document.addEventListener('pp:coleccion:agregadas', function (e) {
      var items = (e && e.detail && e.detail.items) || [];
      for (var a = 0; a < items.length; a++) {
        var ya = false;
        for (var b = 0; b < allCards.length; b++) {
          if (allCards[b].element === items[a]) { ya = true; allCards[b].isLocal = true; break; }
        }
        if (ya) continue;
        var sEl2 = items[a].querySelector('[data-pp-search]');
        allCards.push({ element: items[a], hay: sEl2 ? normalize(sEl2.getAttribute('data-pp-search')) : '', isLocal: true });
      }
      if (input.value.trim()) applyFilter();
    });

    input.addEventListener('input', applyFilter);
    for (var c2 = 0; c2 < clearBtns.length; c2++) {
      clearBtns[c2].addEventListener('click', clear);
    }
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && input.value) {
        e.preventDefault();
        clear();
      }
    });

    // run once in case the browser restored a value from session
    if (input.value) applyFilter();
  }

  function initFiltersAutoSubmit() {
    var form = document.querySelector('[data-pp-filters-form]');
    if (!form) return;

    // FASE 2 (Baymard: selección múltiple): en el CAJÓN del celular cada
    // casilla recargaba la página y cerraba el cajón — para escoger dos
    // medidas había que abrirlo dos veces. Ahí ahora se juntan y se aplican
    // con «Ver resultados» (o al cerrar el cajón: lo escogido no se pierde,
    // pp-collection-filters-drawer.js). En escritorio, la barra lateral sigue
    // aplicando al instante.
    var aplicar = form.querySelector('[data-pp-filters-aplicar]');
    function enCajon() {
      var cajon = form.closest ? form.closest('[data-pp-filters-drawer]') : null;
      return !!(cajon && cajon.classList.contains('is-open'));
    }
    function pendiente() {
      form.setAttribute('data-pp-filtros-pendientes', '');
      if (aplicar) aplicar.hidden = false;
    }

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.type === 'checkbox') {
        if (enCajon()) { pendiente(); return; }
        form.submit();
      }
    });

    var priceTimer = null;
    var priceInputs = form.querySelectorAll('input[type="number"]');
    for (var i = 0; i < priceInputs.length; i++) {
      priceInputs[i].addEventListener('input', function () {
        clearTimeout(priceTimer);
        if (enCajon()) { pendiente(); return; }
        priceTimer = setTimeout(function () { form.submit(); }, 600);
      });
    }
  }

  function initViewToggle() {
    var grid = document.querySelector('[data-pp-grid]');
    var btns = document.querySelectorAll('[data-pp-view]');
    if (!grid || !btns.length) return;

    var stored = null;
    try { stored = localStorage.getItem('pp-col-detail-view'); } catch (e) {}
    if (stored === 'rows' || stored === 'grid') {
      applyView(grid, btns, stored);
    }

    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', (function (view) {
        return function () { applyView(grid, btns, view); };
      })(btns[i].getAttribute('data-pp-view')));
    }
  }

  function applyView(grid, btns, view) {
    if (view === 'rows') {
      grid.classList.add('pp-col-detail__grid--rows');
    } else {
      grid.classList.remove('pp-col-detail__grid--rows');
    }
    for (var i = 0; i < btns.length; i++) {
      var active = btns[i].getAttribute('data-pp-view') === view;
      btns[i].classList.toggle('pp-col-detail__view-btn--active', active);
      btns[i].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
    try { localStorage.setItem('pp-col-detail-view', view); } catch (e) {}
  }

  function initCard(card) {
    var form = card.querySelector('[data-pp-form]');
    if (!form) return;

    var qtyInput = form.querySelector('[data-pp-qty]');
    var decBtn = form.querySelector('[data-pp-qty-dec]');
    var incBtn = form.querySelector('[data-pp-qty-inc]');
    var addBtn = form.querySelector('.pp-prod-card__add');
    if (!qtyInput) return;
    montarStepperMovil(card, form, addBtn);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var action = addBtn ? addBtn.getAttribute('data-pp-action') : 'add';
      if (action === 'view-cart') {
        window.location.href = '/cart';
      } else if (action === 'update') {
        submitUpdateCart(form, card);
      } else {
        submitAddToCart(form, card);
      }
    });

    var priceEl = card.querySelector('[data-pp-price]');
    var savedEl = card.querySelector('[data-pp-saved]');
    var savedPctEl = card.querySelector('[data-pp-saved-pct]');
    var discountEl = card.querySelector('.pp-prod-card__discount');
    var tiersHintEl = card.querySelector('[data-pp-tiers-hint]');
    // querySelectorAll: hay 2 elementos data-pp-unit (uno en __meta
    // de vista cuadricula, otro en __inline-meta de vista lista) y
    // ambos deben actualizarse cuando cambia el tier para que el
    // usuario vea el per-unit correcto al alternar vistas sin reload.
    var unitEls = card.querySelectorAll('[data-pp-unit]');
    var totalItemsEl = card.querySelector('[data-pp-total-items]');
    var totalPriceEl = card.querySelector('[data-pp-total-price]');

    var scrollRaf = null;
    var basePriceCents = parseInt(form.getAttribute('data-pp-base-price'), 10) || 0;
    var compareAtCents = parseInt(form.getAttribute('data-pp-compare-at'), 10) || 0;
    var packSize = parseInt(form.getAttribute('data-pp-pack-size'), 10) || 0;

    var tiers = [];
    try {
      var raw = form.getAttribute('data-pp-tiers') || '[]';
      tiers = JSON.parse(raw);
      if (!Array.isArray(tiers)) tiers = [];
    } catch (e) {
      tiers = [];
    }

    tiers.sort(function (a, b) { return a.min - b.min; });

    // ESCALERA PACTADA (data-pp-breaks): pares [minimo, centavos] que
    // Shopify entrega YA contextuales al comprador B2B. Mismo contrato que
    // usa el PDP. Son precios ABSOLUTOS: el escalón no es un descuento
    // sobre nada, ES el precio que el checkout cobra. Cuando hay breaks,
    // data-pp-tiers viene vacío a propósito (el Liquid apaga los genéricos
    // porque la Shopify Function los salta en variantes pactadas).
    var breaks = [];
    try {
      var rawBreaks = form.getAttribute('data-pp-breaks') || '[]';
      breaks = JSON.parse(rawBreaks);
      if (!Array.isArray(breaks)) breaks = [];
    } catch (eB) {
      breaks = [];
    }
    breaks = breaks.filter(function (b) {
      return Array.isArray(b) && b[0] > 0 && b[1] > 0;
    });
    breaks.sort(function (a, b) { return a[0] - b[0]; });
    var esPacto = breaks.length > 0;

    // UN SOLO CONCEPTO DE ESCALÓN para pintar las pastillas y medir el
    // progreso hacia la siguiente. Lo único que cambia entre pacto y
    // genérico es de dónde sale el precio, y eso vive en update() — no
    // repartido en cada consumidor.
    var escalones = esPacto
      ? breaks.map(function (b) {
          return {
            min: b[0],
            etiqueta: b[0] + '+ ' + formatMoneyShort(b[1]),
            aria: 'Comprar ' + b[0] + ' o más a ' + formatMoneyShort(b[1]) + ' cada uno',
          };
        })
      : tiers.map(function (t) {
          return {
            min: t.min,
            etiqueta: t.min + '+ −' + t.off + '%',
            aria: 'Comprar ' + t.min + ' o más con ' + t.off + '% de descuento',
          };
        });

    var pillNodes = [];
    if (tiersHintEl && escalones.length) {
      tiersHintEl.textContent = '';
      for (var j = 0; j < escalones.length; j++) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'pp-prod-card__tier-pill';
        pill.setAttribute('data-pp-tier-min', escalones[j].min);
        pill.setAttribute('aria-label', escalones[j].aria);
        pill.setAttribute('title', 'Click para subir a ' + escalones[j].min);
        pill.textContent = escalones[j].etiqueta;
        pill.addEventListener('click', (function (min) {
          return function (e) {
            e.preventDefault();
            e.stopPropagation();
            // Celular con la variante en el carrito: la cantidad ES la del
            // carrito (el «− N +»), así que la píldora la cambia ahí.
            if (form.__ppStepper && form.__ppStepper.enCarrito() && esCelular()) {
              form.__ppStepper.ponerEn(min);
              return;
            }
            // Celular sin nada en el carrito (6-oct-2026, el dueño): la
            // píldora ELIGE cuántos paquetes agrega AGREGAR — se marca y el
            // botón lo dice («AGREGAR 4 PAQ.»). Picar otra vez la misma la
            // quita y regresa a 1.
            if (form.__ppStepper && esCelular()) {
              qtyInput.value = (toInt(qtyInput.value) || 1) === min ? 1 : min;
              update();
              return;
            }
            qtyInput.value = min;
            update();
            qtyInput.focus();
          };
        })(escalones[j].min));
        tiersHintEl.appendChild(pill);
        pillNodes.push(pill);
      }
    }

    function clickHandler(e, delta) {
      e.preventDefault();
      e.stopPropagation();
      var current = toInt(qtyInput.value) || 1;
      var next = Math.max(1, current + delta);
      qtyInput.value = next;
      update();
    }

    if (decBtn) {
      decBtn.addEventListener('click', function (e) { clickHandler(e, -1); });
    }
    if (incBtn) {
      incBtn.addEventListener('click', function (e) { clickHandler(e, 1); });
    }

    qtyInput.addEventListener('change', update);
    qtyInput.addEventListener('input', update);

    update();

    function update() {
      var qty = Math.max(1, toInt(qtyInput.value) || 1);
      if (qty !== toInt(qtyInput.value)) qtyInput.value = qty;

      var offPct = 0;
      var activeTierMin = 0;
      for (var k = 0; k < escalones.length; k++) {
        if (qty >= escalones[k].min) {
          activeTierMin = escalones[k].min;
        }
      }
      // El % SOLO existe en el camino genérico. En pacto se queda en 0 y el
      // precio sale de los breaks: si aquí entrara un off, volvería el
      // "pacto − 14%" que A3 enterró en el PDP.
      if (!esPacto) {
        for (var kg = 0; kg < tiers.length; kg++) {
          if (qty >= tiers[kg].min) offPct = tiers[kg].off;
        }
      }

      var nextTier = null;
      for (var k2 = 0; k2 < escalones.length; k2++) {
        if (qty < escalones[k2].min) {
          nextTier = escalones[k2];
          break;
        }
      }

      for (var p = 0; p < pillNodes.length; p++) {
        var pillMin = parseInt(pillNodes[p].getAttribute('data-pp-tier-min'), 10);
        var isActive = pillMin === activeTierMin && activeTierMin > 0;
        var isNext = nextTier && pillMin === nextTier.min;
        pillNodes[p].classList.toggle('pp-prod-card__tier-pill--active', isActive);
        pillNodes[p].classList.toggle('pp-prod-card__tier-pill--next', !isActive && isNext);
        if (form.__ppStepper && esCelular()) pillNodes[p].setAttribute('aria-pressed', isActive ? 'true' : 'false');

        if (isNext) {
          var prevMin = activeTierMin;
          var range = nextTier.min - prevMin;
          var fillPct = 0;
          if (range > 0) {
            fillPct = Math.min(100, Math.max(0, ((qty - prevMin) / range) * 100));
          }
          pillNodes[p].style.setProperty('--pp-tier-fill', fillPct.toFixed(1) + '%');
        } else {
          pillNodes[p].style.removeProperty('--pp-tier-fill');
        }
      }

      // EL PRECIO. En variante pactada es ABSOLUTO: se toma el escalón más
      // barato que la cantidad alcanza, con piso en el pacto plano. Es el
      // espejo exacto de pactoUnitCentsFor() en pp-main-product.js y de la
      // Shopify Function de volumen — las tres tienen que coincidir o la
      // vitrina promete algo que el checkout no cobra.
      var discountedPackCents;
      if (esPacto) {
        discountedPackCents = basePriceCents;
        for (var bi = 0; bi < breaks.length; bi++) {
          if (qty >= breaks[bi][0] && breaks[bi][1] < discountedPackCents) {
            discountedPackCents = breaks[bi][1];
          }
        }
      } else {
        discountedPackCents = basePriceCents * (1 - offPct / 100);
      }

      if (priceEl) priceEl.textContent = formatMoney(discountedPackCents);

      if (unitEls.length > 0) {
        // packSize=1 (productos venta 1-a-1 tipo "1 Rollo") usa el
        // pack price como per-unit. packSize=0 (sin metafield) cae a
        // 1 tambien para que el meta line sea consistente.
        var effectivePack = packSize > 0 ? packSize : 1;
        var perUnitText = formatMoneyShort(discountedPackCents / effectivePack);
        for (var u = 0; u < unitEls.length; u++) {
          unitEls[u].textContent = perUnitText;
        }
      }

      if (totalItemsEl && packSize > 0) {
        var totalUnits = qty * packSize;
        totalItemsEl.textContent = formatPackCount(totalUnits);

        // Plural/singular del unit word — "1 rollo" vs "2 rollos".
        // El summary tiene los dos forms en data-attrs. JS elige el
        // correcto basado en totalUnits.
        var summary = form.querySelector('[data-pp-summary]');
        var unitDisplay = form.querySelector('[data-pp-unit-display]');
        if (summary && unitDisplay) {
          var plural = summary.getAttribute('data-pp-unit-word-plural') || 'unidades';
          var singular = summary.getAttribute('data-pp-unit-word-singular') || 'unidad';
          unitDisplay.textContent = totalUnits === 1 ? singular : plural;
        }
      }

      if (totalPriceEl) {
        // Summary price rounded sin decimales (feedback usuario: las
        // cantidades grandes en summary son ruidosas con centavos).
        // formatMoneyRounded redondea a pesos enteros.
        totalPriceEl.textContent = formatMoneyRounded(discountedPackCents * qty);
      }

      // Auto-scroll del active tier pill a la mitad izquierda del
      // tiers-hint container — cuando el usuario sube qty (8 → 80 → 800)
      // el tier activo siempre queda visible sin que tenga que
      // scrollear manualmente.
      // Perf (fix forced reflow, 2026-08-27): offsetLeft/clientWidth son
      // LECTURAS de layout justo después de las escrituras de arriba
      // (classList/textContent) — leído en síncrono forzaba un re-layout
      // POR TARJETA (24+ por página cuando applyCartIndicators dispara
      // update en cadena; PSI lo acusaba como "Forced reflow"). En rAF
      // todas las escrituras del lote ya ocurrieron: la primera lectura
      // paga un solo layout y las demás lo reusan. El scroll es smooth,
      // así que diferirlo un frame es visualmente idéntico.
      if (tiersHintEl) {
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = null;
          var activePill = tiersHintEl.querySelector('.pp-prod-card__tier-pill--active');
          if (!activePill) return;
          var pillLeft = activePill.offsetLeft;
          var containerWidth = tiersHintEl.clientWidth;
          var targetScroll = pillLeft - containerWidth / 3;
          if (tiersHintEl.scrollTo) {
            tiersHintEl.scrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });
          } else {
            tiersHintEl.scrollLeft = Math.max(0, targetScroll);
          }
        });
      }

      if (savedEl) {
        if (offPct > 0) {
          // Acumular descuento original (compare_at vs base) con el tier
          // activo. El % final es el descuento efectivo del precio
          // descontado contra el compare_at. Si no hay compare_at
          // (producto sin descuento original), mostramos solo el tier.
          // Ej: compare $259, base $228 (-12%), tier 5% sobre $228:
          // $216.6 final → 1 - 216.6/259 = 16.4% → "-16%"
          var displayPct = offPct;
          if (compareAtCents > basePriceCents && compareAtCents > 0) {
            var totalEffectivePct = (1 - discountedPackCents / compareAtCents) * 100;
            displayPct = Math.round(totalEffectivePct);
          }
          savedEl.removeAttribute('hidden');
          if (savedPctEl) savedPctEl.textContent = String(displayPct);
          // Esconder el badge __discount estático para evitar duplicación
          // visual (ambos viven en top-right corner del cover).
          if (discountEl) discountEl.style.display = 'none';
        } else {
          savedEl.setAttribute('hidden', '');
          if (discountEl) discountEl.style.display = '';
        }
      }

      refreshButtonState();
    }

    function refreshButtonState() {
      if (!addBtn) return;
      var inputQty = Math.max(1, toInt(qtyInput.value) || 1);
      var cartQty = parseInt(form.getAttribute('data-pp-cart-qty'), 10) || 0;

      addBtn.classList.remove('pp-prod-card__add--in-cart', 'pp-prod-card__add--update');

      // Button labels (uppercase compactos, feedback usuario):
      //   - cartQty === 0                       → 'AGREGAR'
      //   - cartQty > 0 + inputQty === cartQty  → 'X EN TU CARRITO'
      //   - cartQty > 0 + inputQty !== cartQty  → 'ACTUALIZAR +N' o '-N'
      //     (delta = inputQty - cartQty muestra cuánto va a cambiar)
      if (cartQty > 0 && inputQty === cartQty) {
        addBtn.textContent = cartQty + ' EN TU CARRITO';
        addBtn.classList.add('pp-prod-card__add--in-cart');
        addBtn.setAttribute('data-pp-action', 'view-cart');
      } else if (cartQty > 0 && inputQty !== cartQty) {
        var delta = inputQty - cartQty;
        var deltaLabel = delta > 0 ? '+' + delta : String(delta);
        addBtn.textContent = 'ACTUALIZAR ' + deltaLabel;
        addBtn.classList.add('pp-prod-card__add--update');
        addBtn.setAttribute('data-pp-action', 'update');
      } else {
        // Celular: el selector no se ve, así que el botón dice cuántos
        // paquetes va a agregar cuando la píldora eligió más de 1.
        addBtn.textContent = form.__ppStepper && esCelular() && inputQty > 1
          ? 'AGREGAR ' + inputQty + ' PAQ.'
          : 'AGREGAR';
        addBtn.setAttribute('data-pp-action', 'add');
      }
    }
  }

  function submitAddToCart(form, card) {
    var addBtn = form.querySelector('.pp-prod-card__add');
    if (addBtn) addBtn.setAttribute('disabled', '');

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (err) {
            throw err;
          });
        }
        return r.json();
      })
      .then(function (item) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { return { item: item, cart: cart }; });
      })
      .then(function (data) {
        showNotify(data.item, data.cart, card);
        document.dispatchEvent(new CustomEvent('pp:cart-updated', { detail: data.cart }));
        // Celular: Paco (y su contador) siguen al carrito de la tienda.
        if (form.__ppStepper && esCelular()) document.dispatchEvent(new CustomEvent('pp:cart:updated', { detail: data.cart }));
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'No se pudo agregar al carrito.';
        showNotifyError(msg);
      })
      .then(function () {
        if (addBtn) addBtn.removeAttribute('disabled');
      });
  }

  function submitUpdateCart(form, card) {
    var addBtn = form.querySelector('.pp-prod-card__add');
    if (addBtn) addBtn.setAttribute('disabled', '');

    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('[data-pp-qty]');
    if (!idInput || !qtyInput) return;

    var variantId = idInput.value;
    var newQty = Math.max(1, parseInt(qtyInput.value, 10) || 1);

    // Por la KEY de la línea lisa, no por el id de la variante: con el id,
    // Shopify cambia la PRIMERA línea de esa variante, que puede ser la
    // personalizada (y su cobro la rechaza o se queda desparejado).
    var body = new URLSearchParams();
    var lisa = (form.getAttribute('data-pp-cart-key') || '').split('|');
    if (lisa.length === 3 && lisa[0]) {
      body.append('id', lisa[0]);
      body.append('quantity', String(Math.max(0, (parseInt(lisa[1], 10) || 0) + newQty - (parseInt(lisa[2], 10) || 0))));
    } else {
      body.append('id', variantId);
      body.append('quantity', String(newQty));
    }

    fetch('/cart/change.js', {
      method: 'POST',
      body: body,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (err) { throw err; });
        }
        return r.json();
      })
      .then(function (cart) {
        var titleEl = card.querySelector('.pp-prod-card__title');
        var imgEl = card.querySelector('.pp-prod-card__img');
        var item = {
          product_title: titleEl ? titleEl.textContent.trim() : '',
          quantity: newQty,
          image: imgEl ? (imgEl.currentSrc || imgEl.src) : null
        };
        showNotify(item, cart, card);
        document.dispatchEvent(new CustomEvent('pp:cart-updated', { detail: cart }));
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'No se pudo actualizar el carrito.';
        showNotifyError(msg);
      })
      .then(function () {
        if (addBtn) addBtn.removeAttribute('disabled');
      });
  }

  function showNotify(item, cart, card) {
    if (!notifyEl) return;
    // Suppress the floating toast when the cart drawer is open —
    // the drawer already shows the just-added item with a flash.
    if (document.body.classList.contains('pp-cart-drawer-open')) return;

    var nameEl = notifyEl.querySelector('[data-pp-notify-name]');
    var metaEl = notifyEl.querySelector('[data-pp-notify-meta]');
    var imgEl = notifyEl.querySelector('[data-pp-notify-img]');
    var countEl = notifyEl.querySelector('[data-pp-notify-count]');
    var totalEl = notifyEl.querySelector('[data-pp-notify-cart-total]');

    if (nameEl) nameEl.textContent = item.product_title || item.title || '';
    if (metaEl) {
      var pieces = [];
      pieces.push('Cantidad: ' + item.quantity);
      if (item.line_price !== undefined) pieces.push(formatMoney(item.line_price));
      metaEl.textContent = pieces.join(' · ');
    }

    var cardImg = card ? card.querySelector('.pp-prod-card__img') : null;
    var imgSrc = (cardImg && cardImg.currentSrc) || (cardImg && cardImg.src) || item.image || item.featured_image;
    if (imgEl && imgSrc) {
      imgEl.src = imgSrc;
      imgEl.removeAttribute('hidden');
    } else if (imgEl) {
      imgEl.setAttribute('hidden', '');
    }

    if (countEl) countEl.textContent = String(cart.item_count || 0);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price || 0);

    prepararAviso(false);
    notifyEl.classList.remove('pp-cart-notify--error');
    notifyEl.removeAttribute('hidden');
    requestAnimationFrame(function () {
      notifyEl.classList.add('pp-cart-notify--visible');
    });

    clearTimeout(notifyTimer);
    notifyTimer = setTimeout(hideNotify, NOTIFY_AUTODISMISS_MS);
  }

  /*
   * LA REGIÓN DE AVISO SE RENOMBRA SEGÚN LO QUE VA A DECIR.
   *
   * El <aside> del aviso trae `aria-live="polite"` y
   * `aria-label="Producto agregado al carrito"` FIJOS en el Liquid, y
   * `showNotifyError` reusa ese mismo nodo. Resultado hasta el 5-sep-2026: a
   * quien pedía más piezas de las que hay, el lector le anunciaba el ERROR
   * dentro de una región que se llama literalmente "Producto agregado al
   * carrito". Se quedaba sin saber por qué no pasó nada — o peor, oía que sí
   * pasó.
   *
   * Además el error iba en `polite`, que espera a que el lector termine lo que
   * esté diciendo. Un error de compra es `assertive` + `role="alert"`.
   *
   * Y EL ORDEN IMPORTA: el texto se escribía ANTES de quitar el `hidden`, y
   * con `[hidden]{display:none}` muchas ayudas técnicas no anuncian lo que
   * cambió mientras el nodo estaba oculto. Aquí se destapa primero y se
   * escribe después, en el siguiente frame, para que la mutación ocurra
   * DENTRO de una región viva.
   */
  function prepararAviso(esError) {
    if (!notifyEl) return;
    notifyEl.setAttribute(
      'aria-label',
      esError ? 'No se pudo agregar al carrito' : 'Producto agregado al carrito'
    );
    notifyEl.setAttribute('aria-live', esError ? 'assertive' : 'polite');
    if (esError) notifyEl.setAttribute('role', 'alert');
    else notifyEl.removeAttribute('role');
  }

  function showNotifyError(msg) {
    if (!notifyEl) {
      alert(msg);
      return;
    }
    var nameEl = notifyEl.querySelector('[data-pp-notify-name]');
    var metaEl = notifyEl.querySelector('[data-pp-notify-meta]');
    if (nameEl) nameEl.textContent = '';
    if (metaEl) metaEl.textContent = '';
    prepararAviso(true);
    notifyEl.classList.add('pp-cart-notify--error');
    notifyEl.removeAttribute('hidden');
    requestAnimationFrame(function () {
      notifyEl.classList.add('pp-cart-notify--visible');
      // El texto se escribe con el nodo YA visible: así la ayuda técnica ve
      // la mutación dentro de una región viva y la anuncia.
      if (nameEl) nameEl.textContent = msg;
    });
    clearTimeout(notifyTimer);
    notifyTimer = setTimeout(hideNotify, NOTIFY_AUTODISMISS_MS);
  }

  function hideNotify() {
    if (!notifyEl) return;
    notifyEl.classList.remove('pp-cart-notify--visible');
    clearTimeout(notifyTimer);
    setTimeout(function () {
      if (!notifyEl.classList.contains('pp-cart-notify--visible')) {
        notifyEl.setAttribute('hidden', '');
      }
    }, 300);
  }

  function toInt(v) {
    var n = parseInt(v, 10);
    return isNaN(n) ? 0 : n;
  }

  /**
   * Formatea el count de piezas del paquete con separador de miles
   * ("1000 bolsas" → "1,000 bolsas"). Antes se abreviaba a "1k bolsas",
   * pero clientes lo leían como "1 kilo" — se muestra completo para que
   * quede claro que es CANTIDAD de piezas, no peso.
   */
  function formatPackCount(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function formatMoney(cents) {
    var totalCents = Math.round(cents);
    if (totalCents < 0) totalCents = 0;
    var pesos = Math.floor(totalCents / 100);
    var centavos = totalCents % 100;
    var pesosStr = pesos.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = '$' + pesosStr;
    // Con centavos van SIEMPRE los dos dígitos ("$1.20", "$3.05"); sin
    // centavos no va punto ("$120"). Es el Intl es-MX y lo mismo que
    // pinta pp-money-intl del lado del servidor — un solo formato en
    // todo el sitio. Antes se recortaba el cero final ("$1.20" → "$1.2")
    // y la ficha del mismo producto decía "$1.20"; decisión del Padrino
    // (8-sep-2026): dos decimales en todas las superficies.
    if (centavos > 0) {
      out += '.' + (centavos < 10 ? '0' + centavos : centavos);
    }
    return out + ' MXN';
  }

  /**
   * Mismo formato que formatMoney pero SIN el sufijo " MXN" — usado
   * para el precio por unidad dentro del paréntesis "($X c/u)" donde
   * el "MXN" duplicado se ve ruidoso.
   */
  function formatMoneyShort(cents) {
    return formatMoney(cents).replace(/\s*MXN\s*$/, '');
  }

  /**
   * Formato money sin decimales — solo pesos enteros. Para el summary
   * total ($X MXN) que se ve ruidoso con .50 .70 etc cuando el qty
   * sube. Redondea con Math.round (no floor — para que .60 → 1).
   */
  function formatMoneyRounded(cents) {
    var totalCents = Math.round(cents);
    if (totalCents < 0) totalCents = 0;
    var pesos = Math.round(totalCents / 100);
    var pesosStr = pesos.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + pesosStr + ' MXN';
  }

  // Expose initCardOnce (CON guard ppCardInit) para que otros modulos
  // (e.g. pp-cart-drawer.js) inicialicen cards inyectadas. Usamos
  // initCardOnce y NO initCard: si el MutationObserver tambien agarra la
  // card, el guard evita re-inicializar y duplicar los handlers del qty
  // stepper (bug: el "+" sumaba de 2 en 2 en el modal de recomendaciones).
  window.PpInitCard = initCardOnce;

  /*
   * LA SEGUNDA IMAGEN (hover) SE BAJA SÓLO SI HAY RATÓN.
   *
   * El Liquid la emite con `data-pp-hover` en vez de `src`, así que sin este
   * bloque nunca se descarga. Se le pone el `src` en el primer `pointerover`
   * real de la tarjeta — un evento que en un táctil no ocurre.
   *
   * Medido en la home viva el 5-sep-2026 antes de esto: 26 imágenes
   * distintas, 1.8 MB a 70 KB cada una, bajando en teléfonos para revelar un
   * hover que ahí no existe. `loading="lazy"` sólo retrasaba la descarga
   * hasta el scroll.
   *
   * Delegación en `document` y no un listener por tarjeta: las tarjetas
   * aparecen también por fetch (filtros de colección, modal de
   * recomendaciones, carrito), y así quedan cubiertas sin re-inicializar.
   *
   * `pointerover` y no `mouseover`: el primero distingue el tipo de puntero.
   * Un `pointerType === 'touch'` sí llega en algunos navegadores al tocar, y
   * ahí no queremos bajar nada.
   */
  function despertarHover(e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var card = e.target && e.target.closest && e.target.closest('.pp-prod-card');
    if (!card) return;
    var img = card.querySelector('img[data-pp-hover]');
    if (!img) return;
    var srcset = img.getAttribute('data-pp-hover-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    img.setAttribute('src', img.getAttribute('data-pp-hover'));
    img.removeAttribute('data-pp-hover');
    img.removeAttribute('data-pp-hover-srcset');
  }
  document.addEventListener('pointerover', despertarHover, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
